// import { useState, useMemo, useRef, useEffect, useCallback } from "react";


// const formatBytes = (bytes) => {
//   if (!bytes) return "0 KB";
//   const units = ["B", "KB", "MB", "GB"];
//   const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
//   const value = bytes / Math.pow(1024, i);
//   return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
// };


// const sha256 = async (file) => {
//   const buffer = await file.arrayBuffer();
//   const digest = await crypto.subtle.digest("SHA-256", buffer);
//   return Array.from(new Uint8Array(digest))
//     .map((b) => b.toString(16).padStart(2, "0"))
//     .join("");
// };

// const loadBitmap = async (file) => {
//   try {
//     return await createImageBitmap(file);
//   } catch {
//     return new Promise((resolve, reject) => {
//       const img = new Image();
//       const url = URL.createObjectURL(file);
//       img.onload = () => resolve(img);
//       img.onerror = reject;
//       img.src = url;
//     });
//   }
// };

// const sizeOf = (bmp) => ({
//   w: bmp.naturalWidth || bmp.width,
//   h: bmp.naturalHeight || bmp.height,
// });

// // Perceptual "difference hash": 64 bits describing how brightness changes across the image.
// const dHash = (bmp) => {
//   const canvas = document.createElement("canvas");
//   canvas.width = 9;
//   canvas.height = 8;
//   const ctx = canvas.getContext("2d", { willReadFrequently: true });
//   ctx.drawImage(bmp, 0, 0, 9, 8);
//   const d = ctx.getImageData(0, 0, 9, 8).data;
//   const lum = (i) => d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114;
//   let bits = "";
//   for (let y = 0; y < 8; y++) {
//     for (let x = 0; x < 8; x++) {
//       const i = (y * 9 + x) * 4;
//       bits += lum(i) > lum(i + 4) ? "1" : "0";
//     }
//   }
//   return bits;
// };

// const hamming = (a, b) => {
//   let n = 0;
//   for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) n++;
//   return n;
// };

// /* ---- Folder reading (drag and drop) -------------------------------- */

// const readEntries = (reader) =>
//   new Promise((resolve, reject) => reader.readEntries(resolve, reject));

// const walkEntry = async (entry, parent, out) => {
//   if (entry.isFile) {
//     const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
//     out.push({ file, path: `${parent}${file.name}` });
//   } else if (entry.isDirectory) {
//     const reader = entry.createReader();
//     let batch;
//     do {
//       batch = await readEntries(reader);
//       for (const child of batch) await walkEntry(child, `${parent}${entry.name}/`, out);
//     } while (batch.length);
//   }
// };

// /* ---- Minimal ZIP writer (no dependencies, "store" method = fast) --- */

// const CRC_TABLE = (() => {
//   const t = new Uint32Array(256);
//   for (let n = 0; n < 256; n++) {
//     let c = n;
//     for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
//     t[n] = c >>> 0;
//   }
//   return t;
// })();

// const crc32 = (buf) => {
//   let c = 0xffffffff;
//   for (let i = 0; i < buf.length; i++) c = CRC_TABLE[(c ^ buf[i]) & 0xff] ^ (c >>> 8);
//   return (c ^ 0xffffffff) >>> 0;
// };

// const createZip = async (files, onProgress) => {
//   const enc = new TextEncoder();
//   const now = new Date();
//   const dosTime = (now.getHours() << 11) | (now.getMinutes() << 5) | (now.getSeconds() >> 1);
//   const dosDate = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();

//   const parts = [];
//   const central = [];
//   let offset = 0;
//   let centralSize = 0;

//   for (let i = 0; i < files.length; i++) {
//     const f = files[i];
//     const data = new Uint8Array(await f.blob.arrayBuffer());
//     const name = enc.encode(f.name);
//     const crc = crc32(data);

//     const lh = new DataView(new ArrayBuffer(30));
//     lh.setUint32(0, 0x04034b50, true);
//     lh.setUint16(4, 20, true);
//     lh.setUint16(6, 0x0800, true);
//     lh.setUint16(10, dosTime, true);
//     lh.setUint16(12, dosDate, true);
//     lh.setUint32(14, crc, true);
//     lh.setUint32(18, data.length, true);
//     lh.setUint32(22, data.length, true);
//     lh.setUint16(26, name.length, true);
//     parts.push(lh.buffer, name, data);

//     const ch = new DataView(new ArrayBuffer(46));
//     ch.setUint32(0, 0x02014b50, true);
//     ch.setUint16(4, 20, true);
//     ch.setUint16(6, 20, true);
//     ch.setUint16(8, 0x0800, true);
//     ch.setUint16(12, dosTime, true);
//     ch.setUint16(14, dosDate, true);
//     ch.setUint32(16, crc, true);
//     ch.setUint32(20, data.length, true);
//     ch.setUint32(24, data.length, true);
//     ch.setUint16(28, name.length, true);
//     ch.setUint32(42, offset, true);
//     central.push(ch.buffer, name);

//     offset += 30 + name.length + data.length;
//     centralSize += 46 + name.length;

//     if (onProgress) await onProgress(i + 1, files.length);
//   }

//   const end = new DataView(new ArrayBuffer(22));
//   end.setUint32(0, 0x06054b50, true);
//   end.setUint16(8, files.length, true);
//   end.setUint16(10, files.length, true);
//   end.setUint32(12, centralSize, true);
//   end.setUint32(16, offset, true);

//   return new Blob([...parts, ...central, end.buffer], { type: "application/zip" });
// };

// /* ---- Naming --------------------------------------------------------- */

// /* Name rule: take the file name (without extension), split it by "-" and use index 0.
//    "shirt-red-001.png"  ->  ["shirt", "red", "001"]  ->  "shirt"                        */
// const shortName = (path) => {
//   const fileName = path.split("/").pop();
//   const stem = fileName.replace(/\.[^./]+$/, "");
//   const first = stem.split("-")[0].trim();
//   return first || stem;
// };

// // Original extension is kept (no re-encoding), so the file is never mislabelled.
// const extOf = (path) => {
//   const m = path.split("/").pop().match(/\.([^./]+)$/);
//   return m ? m[1].toLowerCase() : "jpg";
// };

// const toOutPath = (path, keepFolders) => {
//   const dir = keepFolders ? path.split("/").slice(0, -1).join("/") : "";
//   return `${dir ? dir + "/" : ""}${shortName(path)}.${extOf(path)}`;
// };

// /* ---- Minimal XLSX writer (an .xlsx file is a zip of XML parts) ------ */

// const xmlEsc = (v) =>
//   String(v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

// const createXlsx = async (sheetName, headers, rows) => {
//   const all = [headers, ...rows];
//   const col = (i) => String.fromCharCode(65 + i);
//   const widths = headers.map((_, c) =>
//     Math.min(60, Math.max(10, ...all.map((r) => String(r[c] ?? "").length + 2)))
//   );

//   const sheetData = all
//     .map((row, r) => {
//       const cells = row
//         .map((v, c) => {
//           const ref = `${col(c)}${r + 1}`;
//           const style = r === 0 ? ' s="1"' : "";
//           return typeof v === "number"
//             ? `<c r="${ref}"${style}><v>${v}</v></c>`
//             : `<c r="${ref}"${style} t="inlineStr"><is><t xml:space="preserve">${xmlEsc(v)}</t></is></c>`;
//         })
//         .join("");
//       return `<row r="${r + 1}">${cells}</row>`;
//     })
//     .join("");

//   const head = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';
//   const ns = "http://schemas.openxmlformats.org/spreadsheetml/2006/main";
//   const rel = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";
//   const pkg = "http://schemas.openxmlformats.org/package/2006/relationships";

//   const sheet = `${head}<worksheet xmlns="${ns}"><sheetViews><sheetView workbookViewId="0"><pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews><cols>${widths
//     .map((w, i) => `<col min="${i + 1}" max="${i + 1}" width="${w}" customWidth="1"/>`)
//     .join("")}</cols><sheetData>${sheetData}</sheetData><autoFilter ref="A1:${col(headers.length - 1)}${all.length}"/></worksheet>`;

//   const styles = `${head}<styleSheet xmlns="${ns}"><fonts count="2"><font><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="11"/><name val="Calibri"/></font></fonts><fills count="3"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FFCA8A04"/><bgColor indexed="64"/></patternFill></fill></fills><borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="2"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>`;

//   const parts = [
//     {
//       name: "[Content_Types].xml",
//       text: `${head}<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/></Types>`,
//     },
//     {
//       name: "_rels/.rels",
//       text: `${head}<Relationships xmlns="${pkg}"><Relationship Id="rId1" Type="${rel}/officeDocument" Target="xl/workbook.xml"/></Relationships>`,
//     },
//     {
//       name: "xl/workbook.xml",
//       text: `${head}<workbook xmlns="${ns}" xmlns:r="${rel}"><sheets><sheet name="${xmlEsc(sheetName)}" sheetId="1" r:id="rId1"/></sheets></workbook>`,
//     },
//     {
//       name: "xl/_rels/workbook.xml.rels",
//       text: `${head}<Relationships xmlns="${pkg}"><Relationship Id="rId1" Type="${rel}/worksheet" Target="worksheets/sheet1.xml"/><Relationship Id="rId2" Type="${rel}/styles" Target="styles.xml"/></Relationships>`,
//     },
//     { name: "xl/worksheets/sheet1.xml", text: sheet },
//     { name: "xl/styles.xml", text: styles },
//   ];

//   const zip = await createZip(parts.map((p) => ({ name: p.name, blob: new Blob([p.text]) })));
//   return new Blob([zip], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
// };


// const Icon = ({ children, className = "w-5 h-5" }) => (
//   <svg
//     viewBox="0 0 24 24"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="1.8"
//     strokeLinecap="round"
//     strokeLinejoin="round"
//     className={className}
//     aria-hidden="true"
//   >
//     {children}
//   </svg>
// );

// const FolderIcon = (p) => (
//   <Icon {...p}>
//     <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
//   </Icon>
// );
// const ImagesIcon = (p) => (
//   <Icon {...p}>
//     <rect x="3" y="4" width="18" height="16" rx="2" />
//     <circle cx="9" cy="10" r="1.5" />
//     <path d="m21 16-5-5-8 8" />
//   </Icon>
// );
// const DownloadIcon = (p) => (
//   <Icon {...p}>
//     <path d="M12 4v12M7 11l5 5 5-5M4 20h16" />
//   </Icon>
// );
// const CloseIcon = (p) => (
//   <Icon {...p}>
//     <path d="M6 6l12 12M18 6 6 18" />
//   </Icon>
// );
// const TrashIcon = (p) => (
//   <Icon {...p}>
//     <path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12M9 7V4h6v3" />
//   </Icon>
// );
// const CheckIcon = (p) => (
//   <Icon {...p}>
//     <path d="m5 12 5 5 9-10" />
//   </Icon>
// );
// const CopyIcon = (p) => (
//   <Icon {...p}>
//     <rect x="8" y="8" width="12" height="12" rx="2" />
//     <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
//   </Icon>
// );
// const SparkIcon = (p) => (
//   <Icon {...p}>
//     <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" />
//   </Icon>
// );
// const BoltIcon = (p) => (
//   <Icon {...p}>
//     <path d="M13 3 5 14h6l-1 7 8-11h-6l1-7Z" />
//   </Icon>
// );
// const ArrowUpIcon = (p) => (
//   <Icon {...p}>
//     <path d="M12 19V5M6 11l6-6 6 6" />
//   </Icon>
// );
// const ArrowDownIcon = (p) => (
//   <Icon {...p}>
//     <path d="M12 5v14M6 13l6 6 6-6" />
//   </Icon>
// );

// /* ------------------------------------------------------------------ */
// /* Small UI pieces (light theme)                                       */
// /* ------------------------------------------------------------------ */

// const Segmented = ({ options, value, onChange }) => (
//   <div className="flex rounded-xl bg-black/5 p-1">
//     {options.map((o) => (
//       <button
//         key={o.value}
//         type="button"
//         onClick={() => onChange(o.value)}
//         aria-pressed={value === o.value}
//         className={`flex-1 rounded-lg px-3 py-2 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 ${value === o.value
//             ? "bg-white text-black shadow-sm ring-1 ring-black/10"
//             : "text-black/60 hover:text-black"
//           }`}
//       >
//         {o.label}
//       </button>
//     ))}
//   </div>
// );

// const Control = ({ label, hint, children }) => (
//   <div className="flex flex-col gap-2.5">
//     <div className="flex items-center justify-between gap-3">
//       <span className="text-black">{label}</span>
//       {hint && (
//         <span className="rounded-md bg-yellow-600/15 px-2 py-0.5 text-black ring-1 ring-yellow-600/40">
//           {hint}
//         </span>
//       )}
//     </div>
//     {children}
//   </div>
// );

// const stripes = {
//   backgroundImage:
//     "repeating-linear-gradient(135deg, rgba(255,255,255,0.8) 0 12px, rgba(202,138,4,0.3) 12px 14px)",
// };

// const dots = {
//   backgroundImage: "radial-gradient(rgba(0,0,0,0.09) 1px, transparent 1px)",
//   backgroundSize: "22px 22px",
// };

// const primaryBtn =
//   "flex items-center justify-center gap-2 rounded-xl bg-yellow-600 px-6 py-3.5 text-black shadow-sm transition hover:bg-black hover:text-white disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2";
// const secondaryBtn =
//   "flex items-center justify-center gap-2 rounded-xl border border-black/15 bg-white px-6 py-3.5 text-black transition hover:border-black disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 focus-visible:ring-offset-2";

// const DropZone = ({ dragging, busy, onPickFolder, onPickFiles, compact }) =>
//   compact ? (
//     <div
//       className={`flex flex-col gap-4 rounded-2xl border-2 border-dashed p-4 transition sm:flex-row sm:items-center sm:justify-between ${dragging ? "border-yellow-600 bg-yellow-600/15" : "border-yellow-600/50 bg-yellow-600/5"
//         }`}
//     >
//       <div className="flex items-center gap-3">
//         <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-yellow-600 shadow-sm ring-1 ring-yellow-600/30">
//           <FolderIcon className="h-5 w-5" />
//         </span>
//         <div>
//           <div className="text-black">{dragging ? "Release to add" : "Add more images"}</div>
//           <div className="text-black/55">Or drop another folder anywhere on this page.</div>
//         </div>
//       </div>
//       <div className="flex gap-2">
//         <button
//           type="button"
//           onClick={onPickFolder}
//           disabled={busy}
//           className="flex-1 rounded-xl bg-yellow-600 px-4 py-2.5 text-black transition hover:bg-black hover:text-white disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 sm:flex-none"
//         >
//           Folder
//         </button>
//         <button
//           type="button"
//           onClick={onPickFiles}
//           disabled={busy}
//           className="flex-1 rounded-xl border border-black/15 bg-white px-4 py-2.5 text-black transition hover:border-black disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 focus-visible:ring-offset-2 sm:flex-none"
//         >
//           Files
//         </button>
//       </div>
//     </div>
//   ) : (
//     <div
//       className={`rounded-3xl border-2 border-dashed p-8 text-center shadow-xl shadow-black/5 transition sm:p-12 ${dragging ? "border-yellow-600 bg-yellow-600/15" : "border-yellow-600/60 bg-white"
//         }`}
//     >
//       <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-yellow-600/10 text-yellow-600 ring-1 ring-yellow-600/30">
//         <FolderIcon className="h-10 w-10" />
//       </div>
//       <h2 className="mt-6 text-black">{dragging ? "Release to add this folder" : "Drop your folder here"}</h2>
//       <p className="mx-auto mt-2 max-w-xs text-black/55">
//         Subfolders are included. Anything that isn't an image is skipped.
//       </p>
//       <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:justify-center">
//         <button type="button" onClick={onPickFolder} disabled={busy} className={primaryBtn}>
//           <FolderIcon className="h-5 w-5" />
//           Choose folder
//         </button>
//         <button type="button" onClick={onPickFiles} disabled={busy} className={secondaryBtn}>
//           <ImagesIcon className="h-5 w-5" />
//           Choose files
//         </button>
//       </div>
//     </div>
//   );

// const StatCard = ({ icon, label, value, sub, accent }) => (
//   <div
//     className={`rounded-2xl border p-4 shadow-sm ${accent ? "border-yellow-600/40 bg-yellow-600/10" : "border-black/10 bg-white"
//       }`}
//   >
//     <div className="flex items-center gap-2 text-black/60">
//       <span
//         className={`flex h-7 w-7 items-center justify-center rounded-lg ${accent ? "bg-yellow-600 text-black" : "bg-black/5 text-black"
//           }`}
//       >
//         {icon}
//       </span>
//       {label}
//     </div>
//     <div className="mt-3 text-black">{value}</div>
//     <div className="text-black/50">{sub}</div>
//   </div>
// );

// /* One image card, used in every gallery view */
// const ImageCard = ({ it, dup, onRemove, onKeep, note }) => {
//   const dir = it.path.split("/").slice(0, -1).join("/");
//   return (
//     <li
//       className={`flex flex-col overflow-hidden rounded-2xl border bg-white shadow-sm transition hover:shadow-lg hover:shadow-black/10 ${dup ? "border-yellow-600" : "border-black/10"
//         }`}
//     >
//       <div className="relative aspect-square bg-black/5">
//         <img
//           src={it.url}
//           alt={it.file.name}
//           loading="lazy"
//           className="h-full w-full object-cover"
//         />
//         {dup && <div className="absolute inset-0" style={stripes} />}
//         <span
//           className={`absolute left-2 top-2 flex items-center gap-1.5 rounded-full px-2.5 py-1 shadow-sm ${dup ? "bg-black text-white" : "bg-white text-black ring-1 ring-black/10"
//             }`}
//         >
//           {!dup && <span className="h-2 w-2 rounded-full bg-yellow-600" />}
//           {dup ? "Duplicate" : "Keeping"}
//         </span>
//         <button
//           type="button"
//           onClick={() => onRemove(it.id)}
//           aria-label={`Remove ${it.file.name}`}
//           className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow transition hover:bg-black hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
//         >
//           <CloseIcon className="h-4 w-4" />
//         </button>
//         <span className="absolute bottom-2 right-2 rounded-md bg-black/70 px-1.5 py-0.5 uppercase text-white">
//           {extOf(it.path)}
//         </span>
//       </div>
//       <div className="flex flex-1 flex-col p-3">
//         <div className="truncate text-black" title={it.file.name}>
//           {it.file.name}
//         </div>
//         {dir && (
//           <div className="truncate text-black/45" title={dir}>
//             {dir}
//           </div>
//         )}
//         <div className="text-black/60">
//           {formatBytes(it.file.size)} · {it.w}×{it.h}
//         </div>
//         {!dup && (
//           <div className="mt-1 truncate text-black/45">
//             Saved as {shortName(it.path)}.{extOf(it.path)}
//           </div>
//         )}
//         {dup && (
//           <div className="mt-auto border-t border-black/10 pt-2">
//             {note && (
//               <div className="truncate text-black/70" title={note}>
//                 {note}
//               </div>
//             )}
//             <button
//               type="button"
//               onClick={() => onKeep(it.id)}
//               className="mt-1 rounded text-black underline decoration-yellow-600 decoration-2 underline-offset-4 hover:bg-yellow-600/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
//             >
//               Keep anyway
//             </button>
//           </div>
//         )}
//       </div>
//     </li>
//   );
// };

// /* ------------------------------------------------------------------ */
// /* Page                                                                */
// /* ------------------------------------------------------------------ */

// export default function DuplicateImageCleaner() {
//   const [items, setItems] = useState([]);
//   const [mode, setMode] = useState("exact");
//   const [keepFolders, setKeepFolders] = useState(true);
//   const [filter, setFilter] = useState("groups");
//   const [keepIds, setKeepIds] = useState(() => new Set());
//   const [dragging, setDragging] = useState(false);
//   const [status, setStatus] = useState(null); // { label, done, total }
//   const [result, setResult] = useState(null);
//   const [scrollInfo, setScrollInfo] = useState({ atTop: true, atBottom: false, scrollable: false });
//   const folderRef = useRef(null);
//   const filesRef = useRef(null);
//   const urlsRef = useRef([]);
//   const busy = status !== null;

//   useEffect(
//     () => () => {
//       urlsRef.current.forEach((u) => URL.revokeObjectURL(u));
//     },
//     []
//   );

//   const clearResult = useCallback(() => {
//     setResult((prev) => {
//       if (prev) URL.revokeObjectURL(prev.url);
//       return null;
//     });
//   }, []);

//   /* ---- Scroll tracking for the jump buttons ---- */
//   useEffect(() => {
//     const update = () => {
//       const y = window.scrollY;
//       const max = document.documentElement.scrollHeight - window.innerHeight;
//       setScrollInfo({ atTop: y < 80, atBottom: y > max - 80, scrollable: max > 300 });
//     };
//     update();
//     window.addEventListener("scroll", update, { passive: true });
//     window.addEventListener("resize", update);
//     const t = setTimeout(update, 300); // after images lay out
//     return () => {
//       window.removeEventListener("scroll", update);
//       window.removeEventListener("resize", update);
//       clearTimeout(t);
//     };
//   }, [items.length, filter]);

//   const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
//   const goBottom = () =>
//     window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });

//   /* ---- Add files (folder picker, file picker or drop) ---- */
//   const addEntries = useCallback(
//     async (entries) => {
//       const images = entries.filter((e) => e.file.type.startsWith("image/"));
//       if (!images.length) {
//         setStatus(null);
//         return;
//       }
//       clearResult();
//       const added = [];
//       const BATCH = 4;
//       for (let i = 0; i < images.length; i += BATCH) {
//         setStatus({ label: "Scanning images", done: i, total: images.length });
//         const done = await Promise.all(
//           images.slice(i, i + BATCH).map(async ({ file, path }, k) => {
//             try {
//               const [hash, bmp] = await Promise.all([sha256(file), loadBitmap(file)]);
//               const { w, h } = sizeOf(bmp);
//               const bits = dHash(bmp);
//               if (bmp.close) bmp.close();
//               const url = URL.createObjectURL(file);
//               urlsRef.current.push(url);
//               return {
//                 id: `${Date.now()}-${i + k}-${Math.random().toString(36).slice(2, 7)}`,
//                 file,
//                 path,
//                 url,
//                 hash,
//                 dhash: bits,
//                 w,
//                 h,
//               };
//             } catch {
//               return null; // unreadable file
//             }
//           })
//         );
//         added.push(...done.filter(Boolean));
//       }
//       setItems((prev) => [...prev, ...added]);
//       setStatus(null);
//     },
//     [clearResult]
//   );

//   const fromInput = (e) => {
//     const entries = Array.from(e.target.files || []).map((file) => ({
//       file,
//       path: file.webkitRelativePath || file.name,
//     }));
//     e.target.value = "";
//     addEntries(entries);
//   };

//   const onDrop = async (e) => {
//     e.preventDefault();
//     setDragging(false);
//     setStatus({ label: "Reading folder", done: 0, total: 1 });
//     // Entries must be grabbed synchronously, before any await.
//     const roots = Array.from(e.dataTransfer.items || [])
//       .map((i) => (i.webkitGetAsEntry ? i.webkitGetAsEntry() : null))
//       .filter(Boolean);
//     const plain = Array.from(e.dataTransfer.files || []);
//     const out = [];
//     try {
//       if (roots.length) for (const r of roots) await walkEntry(r, "", out);
//       else plain.forEach((file) => out.push({ file, path: file.name }));
//     } catch {
//       plain.forEach((file) => out.push({ file, path: file.name }));
//     }
//     addEntries(out);
//   };

//   /* ---- Duplicate analysis ---- */
//   const { dupMap, keptItems } = useMemo(() => {
//     const kept = [];
//     const map = {};
//     for (const it of items) {
//       let match = null;
//       let reason = "";
//       for (const k of kept) {
//         if (k.hash === it.hash) {
//           match = k;
//           reason = "Identical to";
//           break;
//         }
//         if (mode === "similar") {
//           const sameShape = Math.abs(k.w / k.h - it.w / it.h) < 0.03;
//           if (sameShape && hamming(k.dhash, it.dhash) <= 4) {
//             match = k;
//             reason = "Looks like";
//             break;
//           }
//         }
//       }
//       if (match && !keepIds.has(it.id)) map[it.id] = { of: match, reason };
//       else kept.push(it);
//     }
//     return { dupMap: map, keptItems: kept };
//   }, [items, mode, keepIds]);

//   const dupCount = items.length - keptItems.length;

//   // Groups: each kept image followed by the images identical to it, in upload order.
//   const groups = useMemo(() => {
//     const m = new Map();
//     items.forEach((it) => {
//       const d = dupMap[it.id];
//       if (!d) return;
//       if (!m.has(d.of.id)) m.set(d.of.id, { original: d.of, dups: [] });
//       m.get(d.of.id).dups.push(it);
//     });
//     return keptItems
//       .filter((k) => m.has(k.id))
//       .map((k, i) => ({ no: i + 1, ...m.get(k.id) }));
//   }, [items, dupMap, keptItems]);

//   const totalBytes = items.reduce((s, i) => s + i.file.size, 0);
//   const keptBytes = keptItems.reduce((s, i) => s + i.file.size, 0);
//   const dupBytes = totalBytes - keptBytes;
//   const folderCount = new Set(
//     items.map((i) => i.path.split("/").slice(0, -1).join("/")).filter(Boolean)
//   ).size;

//   const visible = items.filter((i) =>
//     filter === "all" ? true : filter === "duplicates" ? !!dupMap[i.id] : !dupMap[i.id]
//   );

//   /* ---- Item actions ---- */
//   const removeItem = (id) => {
//     clearResult();
//     setItems((prev) => prev.filter((i) => i.id !== id));
//   };
//   const keepAnyway = (id) => {
//     clearResult();
//     setKeepIds((prev) => new Set(prev).add(id));
//   };
//   const clearAll = () => {
//     clearResult();
//     urlsRef.current.forEach((u) => URL.revokeObjectURL(u));
//     urlsRef.current = [];
//     setItems([]);
//     setKeepIds(new Set());
//     setFilter("groups");
//   };
//   const change = (setter) => (value) => {
//     clearResult();
//     setter(value);
//   };

//   /* ---- Downloads ---- */
//   const download = (url, filename = "unique-images.zip") => {
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = filename;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//   };

//   const downloadExcel = async () => {
//     if (!groups.length || busy) return;
//     const headers = [
//       "S.No",
//       "Group",
//       "Name",
//       "File Name",
//       "File Path",
//       "Identical To (Name)",
//       "Identical To (File)",
//       "Match",
//       "Size (KB)",
//     ];
//     const rows = [];
//     groups.forEach((g) =>
//       g.dups.forEach((d) =>
//         rows.push([
//           rows.length + 1,
//           g.no,
//           shortName(d.path), // index 0 of file name split by "-"
//           d.file.name,
//           d.path,
//           shortName(g.original.path),
//           g.original.file.name,
//           dupMap[d.id].reason === "Identical to" ? "Identical" : "Similar",
//           Math.round(d.file.size / 102.4) / 10,
//         ])
//       )
//     );
//     const blob = await createXlsx("Duplicate images", headers, rows);
//     const url = URL.createObjectURL(blob);
//     download(url, "duplicate-images.xlsx");
//     setTimeout(() => URL.revokeObjectURL(url), 10000);
//   };

//   // Fast path: original files are copied into the zip as they are (no re-encoding).
//   const buildZip = async () => {
//     if (!keptItems.length || busy) return;
//     clearResult();
//     const used = new Set();
//     const out = keptItems.map((it) => {
//       const base = toOutPath(it.path, keepFolders);
//       let name = base;
//       let n = 1;
//       while (used.has(name.toLowerCase())) {
//         name = base.replace(/(\.[^./]+)$/, `_${n}$1`);
//         n++;
//       }
//       used.add(name.toLowerCase());
//       return { name, blob: it.file };
//     });

//     setStatus({ label: "Creating zip", done: 0, total: out.length });
//     let lastPaint = 0;
//     const zip = await createZip(out, async (done, total) => {
//       const now = performance.now();
//       if (done === total || now - lastPaint > 120) {
//         lastPaint = now;
//         setStatus({ label: "Creating zip", done, total });
//         await new Promise((res) => setTimeout(res, 0)); // let the UI repaint
//       }
//     });
//     const url = URL.createObjectURL(zip);
//     setResult({ url, count: out.length, size: zip.size });
//     setStatus(null);
//     download(url);
//   };


//   const hasItems = items.length > 0;

//   const openFolder = () => folderRef.current?.click();
//   const openFiles = () => filesRef.current?.click();

//   const dropProps = {
//     onDragOver: (e) => {
//       e.preventDefault();
//       setDragging(true);
//     },
//     onDragLeave: (e) => {
//       if (e.currentTarget === e.target) setDragging(false);
//     },
//     onDrop,
//   };

//   const progress = status && (
//     <div role="status">
//       <div className="flex justify-between text-black/70">
//         <span>{status.label}</span>
//         <span>
//           {status.done} / {status.total}
//         </span>
//       </div>
//       <div className="mt-2 h-2 overflow-hidden rounded-full bg-black/10">
//         <div
//           className="h-full rounded-full bg-yellow-600 transition-all"
//           style={{ width: `${Math.max(5, (status.done / status.total) * 100)}%` }}
//         />
//       </div>
//     </div>
//   );

//   const mainAction = result ? () => download(result.url) : buildZip;
//   const mainLabel = busy ? "Working…" : result ? "Download zip again" : "Remove duplicates & download";

//   /* ------------------------------------------------------------------ */

//   return (
//     <div className="min-h-screen bg-white text-black" {...dropProps}>
//       <input
//         ref={folderRef}
//         type="file"
//         multiple
//         webkitdirectory=""
//         directory=""
//         className="hidden"
//         onChange={fromInput}
//       />
//       <input ref={filesRef} type="file" accept="image/*" multiple className="hidden" onChange={fromInput} />

//       {/* ---------------- Empty state ---------------- */}
//       {!hasItems && (
//         <>
//           <section className="relative overflow-hidden" style={dots}>
//             <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-yellow-600/15 blur-3xl" />
//             <div className="pointer-events-none absolute -bottom-40 right-0 h-96 w-96 rounded-full bg-yellow-600/10 blur-3xl" />
//             <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 py-14 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24">
//               <div>
//                 <span className="inline-flex items-center gap-2 rounded-full bg-yellow-600/15 px-3 py-1.5 text-black ring-1 ring-yellow-600/40">
//                   <SparkIcon className="h-4 w-4 text-yellow-600" />
//                   Fast duplicate image remover
//                 </span>
//                 <h1 className="mt-5 max-w-xl text-black">
//                   Turn a messy folder of images into one clean zip, instantly.
//                 </h1>
//                 <p className="mt-4 max-w-lg text-black/60">
//                   Upload a folder, we remove the duplicates and zip the rest. Images are copied as
//                   they are, with no re-compression, so the download is quick and quality is untouched.
//                 </p>

//                 <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4">
//                   {[
//                     ["Folders", "with subfolders"],
//                     ["Original", "quality kept"],
//                     ["0 uploads", "all in-browser"],
//                   ].map(([a, b]) => (
//                     <div key={a} className="border-l-2 border-yellow-600 pl-3">
//                       <dt className="text-black">{a}</dt>
//                       <dd className="text-black/55">{b}</dd>
//                     </div>
//                   ))}
//                 </dl>
//               </div>

//               <div>
//                 <DropZone
//                   dragging={dragging}
//                   busy={busy}
//                   onPickFolder={openFolder}
//                   onPickFiles={openFiles}
//                 />
//                 {status && (
//                   <div className="mt-5 rounded-2xl border border-black/10 bg-white p-4 shadow-sm">
//                     {progress}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </section>

//           <section className="border-t border-black/10 bg-black/[0.03]">
//             <div className="mx-auto grid max-w-7xl gap-4 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-8">
//               {[
//                 [<CopyIcon key="i" className="h-5 w-5" />, "Finds duplicates", "Exact copies are caught every time. Turn on Similar to also catch re-saved or resized copies."],
//                 [<BoltIcon key="i" className="h-5 w-5" />, "Quick download", "No resizing or re-encoding. Original files go straight into the zip."],
//                 [<DownloadIcon key="i" className="h-5 w-5" />, "Zips it for you", "Folder structure is kept, and files are renamed with the text before the first “-”."],
//               ].map(([icon, t, d]) => (
//                 <div key={t} className="rounded-2xl border border-black/10 bg-white p-6 shadow-sm">
//                   <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-yellow-600/15 text-yellow-600 ring-1 ring-yellow-600/30">
//                     {icon}
//                   </span>
//                   <div className="mt-4 text-black">{t}</div>
//                   <p className="mt-2 text-black/60">{d}</p>
//                 </div>
//               ))}
//             </div>
//           </section>
//         </>
//       )}

//       {/* ---------------- Workbench ---------------- */}
//       {hasItems && (
//         <main className="mx-auto grid max-w-7xl gap-8 bg-white px-4 py-8 pb-32 sm:px-6 lg:grid-cols-[22rem_minmax(0,1fr)] lg:px-8 lg:pb-12">
//           {/* Settings panel */}
//           <aside className="self-start lg:sticky lg:top-6">
//             <div className="rounded-3xl border border-black/10 bg-white p-5 shadow-xl shadow-black/5 sm:p-6">
//               <div className="flex items-center justify-between">
//                 <h2 className="flex items-center gap-2 text-black">
//                   <span className="h-2.5 w-2.5 rounded-full bg-yellow-600" />
//                   Output settings
//                 </h2>
//                 <span className="rounded-md bg-black px-2.5 py-1 text-white">original format</span>
//               </div>

//               <div className="mt-6 grid gap-6">
//                 <Control label="Duplicate detection" hint={mode === "exact" ? "Strict" : "Flexible"}>
//                   <Segmented
//                     value={mode}
//                     onChange={change(setMode)}
//                     options={[
//                       { value: "exact", label: "Exact" },
//                       { value: "similar", label: "Similar" },
//                     ]}
//                   />
//                 </Control>

//                 <Control label="Zip layout">
//                   <Segmented
//                     value={keepFolders ? "keep" : "flat"}
//                     onChange={(v) => change(setKeepFolders)(v === "keep")}
//                     options={[
//                       { value: "keep", label: "Keep folders" },
//                       { value: "flat", label: "Flat" },
//                     ]}
//                   />
//                 </Control>

//                 <p className="rounded-xl bg-yellow-600/10 p-3 text-black/70 ring-1 ring-yellow-600/30">
//                   File names in the zip use the text before the first “-”. For example,{" "}
//                   <span className="text-black">shirt-red-01.png</span> is saved as{" "}
//                   <span className="text-black">shirt.png</span>. Images are not re-compressed.
//                 </p>
//               </div>

//               <div className="mt-6 rounded-2xl bg-black/[0.04] p-4">
//                 {result ? (
//                   <div>
//                     <div className="flex items-center justify-between gap-3">
//                       <span className="text-black/60">Zip ready</span>
//                       <span className="rounded-md bg-yellow-600 px-2 py-0.5 text-black">
//                         {result.count} images
//                       </span>
//                     </div>
//                     <div className="mt-2 text-black">{formatBytes(result.size)}</div>
//                   </div>
//                 ) : (
//                   <div className="flex items-end justify-between gap-3">
//                     <div>
//                       <div className="text-black/60">Ready to process</div>
//                       <div className="mt-1 text-black">{keptItems.length} images</div>
//                     </div>
//                     <div className="text-black/60">{formatBytes(keptBytes)}</div>
//                   </div>
//                 )}
//                 {busy && <div className="mt-4">{progress}</div>}
//               </div>

//               <button
//                 type="button"
//                 onClick={mainAction}
//                 disabled={busy || !keptItems.length}
//                 className={`${primaryBtn} mt-5 hidden w-full lg:flex`}
//               >
//                 <DownloadIcon className="h-5 w-5" />
//                 {mainLabel}
//               </button>
//             </div>
//           </aside>

//           {/* Gallery */}
//           <section className="min-w-0">
//             <DropZone
//               compact
//               dragging={dragging}
//               busy={busy}
//               onPickFolder={openFolder}
//               onPickFiles={openFiles}
//             />

//             <div className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
//               <StatCard
//                 icon={<ImagesIcon className="h-4 w-4" />}
//                 label="Found"
//                 value={items.length}
//                 sub={`${folderCount ? folderCount + " folders · " : ""}${formatBytes(totalBytes)}`}
//               />
//               <StatCard
//                 accent
//                 icon={<CopyIcon className="h-4 w-4" />}
//                 label="Duplicates"
//                 value={dupCount}
//                 sub={`${formatBytes(dupBytes)} freed`}
//               />
//               <StatCard
//                 icon={<CheckIcon className="h-4 w-4" />}
//                 label="Unique"
//                 value={keptItems.length}
//                 sub={formatBytes(keptBytes)}
//               />
//               <StatCard
//                 icon={<DownloadIcon className="h-4 w-4" />}
//                 label="Zip size"
//                 value={result ? formatBytes(result.size) : "—"}
//                 sub={result ? `${result.count} images` : "after download"}
//               />
//             </div>

//             {/* Sticky toolbar: tabs + actions stay visible while scrolling */}
//             <div className="sticky top-0 z-10 -mx-4 mt-6 border-b border-black/10 bg-white/95 px-4 py-3 backdrop-blur sm:-mx-6 sm:px-6 lg:mx-0 lg:rounded-2xl lg:border lg:px-3">
//               <div className="flex flex-wrap items-center justify-between gap-3">
//                 <div className="flex max-w-full overflow-x-auto rounded-xl bg-black/5 p-1">
//                   {[
//                     { v: "groups", l: "By image", n: groups.length },
//                     { v: "all", l: "All", n: items.length },
//                     { v: "unique", l: "Unique", n: keptItems.length },
//                     { v: "duplicates", l: "Duplicates", n: dupCount },
//                   ].map((t) => (
//                     <button
//                       key={t.v}
//                       type="button"
//                       onClick={() => setFilter(t.v)}
//                       aria-pressed={filter === t.v}
//                       className={`flex items-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 ${filter === t.v
//                           ? "bg-white text-black shadow-sm ring-1 ring-black/10"
//                           : "text-black/60 hover:text-black"
//                         }`}
//                     >
//                       {t.l}
//                       <span
//                         className={`rounded-md px-1.5 ${filter === t.v ? "bg-yellow-600 text-black" : "bg-black/10 text-black"
//                           }`}
//                       >
//                         {t.n}
//                       </span>
//                     </button>
//                   ))}
//                 </div>
//                 <div className="flex flex-wrap gap-2">
//                   <button
//                     type="button"
//                     onClick={downloadExcel}
//                     disabled={busy || !groups.length}
//                     className="flex items-center gap-2 rounded-xl bg-yellow-600 px-4 py-2.5 text-black shadow-sm transition hover:bg-black hover:text-white disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
//                   >
//                     <DownloadIcon className="h-4 w-4" />
//                     Duplicates Excel
//                   </button>
//                   <button
//                     type="button"
//                     onClick={clearAll}
//                     disabled={busy}
//                     className="flex items-center gap-2 rounded-xl border border-black/15 bg-white px-4 py-2.5 text-black transition hover:border-black disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
//                   >
//                     <TrashIcon className="h-4 w-4" />
//                     Start over
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {filter === "groups" ? (
//               groups.length === 0 ? (
//                 <div className="mt-6 rounded-2xl border border-dashed border-black/20 p-12 text-center text-black/55">
//                   No duplicates found. Open the All tab to see every image.
//                 </div>
//               ) : (
//                 <ol className="mt-6 grid gap-6">
//                   {groups.map((g) => (
//                     <li
//                       key={g.original.id}
//                       className="overflow-hidden rounded-3xl border border-black/10 bg-white shadow-sm"
//                     >
//                       {/* Group header: the image being kept */}
//                       <div className="flex flex-wrap items-center gap-4 border-b border-black/10 bg-yellow-600/10 p-4">
//                         <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-yellow-600 text-black">
//                           {g.no}
//                         </span>
//                         <img
//                           src={g.original.url}
//                           alt={g.original.file.name}
//                           className="h-24 w-24 shrink-0 rounded-2xl object-cover ring-1 ring-black/10"
//                         />
//                         <div className="min-w-0 flex-1">
//                           <div className="text-black/55">Original (kept)</div>
//                           <div className="truncate text-black" title={g.original.path}>
//                             {g.original.file.name}
//                           </div>
//                           <div className="truncate text-black/55">
//                             {formatBytes(g.original.file.size)} · {g.original.w}×{g.original.h}
//                           </div>
//                           <div className="mt-1 text-black/55">
//                             Saved as{" "}
//                             <span className="rounded bg-white px-1.5 text-black ring-1 ring-yellow-600/40">
//                               {shortName(g.original.path)}.{extOf(g.original.path)}
//                             </span>
//                           </div>
//                         </div>
//                         <span className="rounded-full bg-black px-3 py-1 text-white">
//                           {g.dups.length} {g.dups.length === 1 ? "duplicate" : "duplicates"}
//                         </span>
//                       </div>

//                       {/* Duplicates as a clean grid of cards */}
//                       <ul className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3 sm:gap-4 xl:grid-cols-4">
//                         {g.dups.map((d, i) => (
//                           <ImageCard
//                             key={d.id}
//                             it={d}
//                             dup
//                             onRemove={removeItem}
//                             onKeep={keepAnyway}
//                             note={`${g.no}.${i + 1} · ${dupMap[d.id].reason === "Identical to" ? "Identical" : "Similar"
//                               } to original`}
//                           />
//                         ))}
//                       </ul>
//                     </li>
//                   ))}
//                 </ol>
//               )
//             ) : visible.length === 0 ? (
//               <div className="mt-6 rounded-2xl border border-dashed border-black/20 p-12 text-center text-black/55">
//                 No images in this view.
//               </div>
//             ) : (
//               <ul className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 xl:grid-cols-4">
//                 {visible.map((it) => {
//                   const dup = dupMap[it.id];
//                   return (
//                     <ImageCard
//                       key={it.id}
//                       it={it}
//                       dup={!!dup}
//                       onRemove={removeItem}
//                       onKeep={keepAnyway}
//                       note={dup ? `${dup.reason} ${dup.of.file.name}` : ""}
//                     />
//                   );
//                 })}
//               </ul>
//             )}
//           </section>
//         </main>
//       )}

//       {/* Jump to top / bottom */}
//       {hasItems && scrollInfo.scrollable && (
//         <div className="fixed bottom-24 right-4 z-30 flex flex-col gap-2 lg:bottom-6 lg:right-6">
//           <button
//             type="button"
//             onClick={goTop}
//             disabled={scrollInfo.atTop}
//             aria-label="Go to top"
//             title="Go to top"
//             className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-black shadow-lg ring-1 ring-black/10 transition hover:bg-black hover:text-white disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
//           >
//             <ArrowUpIcon className="h-6 w-6" />
//           </button>
//           <button
//             type="button"
//             onClick={goBottom}
//             disabled={scrollInfo.atBottom}
//             aria-label="Go to bottom"
//             title="Go to bottom"
//             className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-black shadow-lg ring-1 ring-black/10 transition hover:bg-black hover:text-white disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
//           >
//             <ArrowDownIcon className="h-6 w-6" />
//           </button>
//         </div>
//       )}

//       {/* Mobile action bar */}
//       {hasItems && (
//         <div className="fixed inset-x-0 bottom-0 z-20 border-t border-black/10 bg-white/95 p-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] backdrop-blur lg:hidden">
//           <div className="mx-auto flex max-w-xl items-center gap-3">
//             <div className="min-w-0 flex-1 text-black/70">
//               {result ? (
//                 <span className="text-black">
//                   {result.count} images · {formatBytes(result.size)}
//                 </span>
//               ) : (
//                 <span>
//                   {keptItems.length} images · {formatBytes(keptBytes)}
//                 </span>
//               )}
//             </div>
//             <button
//               type="button"
//               onClick={mainAction}
//               disabled={busy || !keptItems.length}
//               className="flex shrink-0 items-center gap-2 rounded-xl bg-yellow-600 px-4 py-3 text-black shadow-sm disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
//             >
//               <DownloadIcon className="h-5 w-5" />
//               {busy ? "Working…" : result ? "Download again" : "Download zip"}
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }








import { useState, useMemo, useRef, useEffect, useCallback } from "react";

const formatBytes = (bytes) => {
  if (!bytes) return "0 KB";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
};

const sha256 = async (file) => {
  const buffer = await file.arrayBuffer();
  const digest = await crypto.subtle.digest("SHA-256", buffer);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

const loadBitmap = async (file) => {
  try {
    return await createImageBitmap(file);
  } catch {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }
};

const sizeOf = (bmp) => ({
  w: bmp.naturalWidth || bmp.width,
  h: bmp.naturalHeight || bmp.height,
});

// Perceptual "difference hash": 64 bits describing how brightness changes across the image.
const dHash = (bmp) => {
  const canvas = document.createElement("canvas");
  canvas.width = 9;
  canvas.height = 8;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  ctx.drawImage(bmp, 0, 0, 9, 8);
  const d = ctx.getImageData(0, 0, 9, 8).data;
  const lum = (i) => d[i] * 0.299 + d[i + 1] * 0.587 + d[i + 2] * 0.114;
  let bits = "";
  for (let y = 0; y < 8; y++) {
    for (let x = 0; x < 8; x++) {
      const i = (y * 9 + x) * 4;
      bits += lum(i) > lum(i + 4) ? "1" : "0";
    }
  }
  return bits;
};

const hamming = (a, b) => {
  let n = 0;
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) n++;
  return n;
};

/* ---- Folder reading (drag and drop) -------------------------------- */

const readEntries = (reader) =>
  new Promise((resolve, reject) => reader.readEntries(resolve, reject));

const walkEntry = async (entry, parent, out) => {
  if (entry.isFile) {
    const file = await new Promise((resolve, reject) => entry.file(resolve, reject));
    out.push({ file, path: `${parent}${file.name}` });
  } else if (entry.isDirectory) {
    const reader = entry.createReader();
    let batch;
    do {
      batch = await readEntries(reader);
      for (const child of batch) await walkEntry(child, `${parent}${entry.name}/`, out);
    } while (batch.length);
  }
};

/* ---- Minimal ZIP writer (no dependencies, "store" method = fast) --- */

const CRC_TABLE = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();

const crc32 = (buf) => {
  let c = 0xffffffff;
  for (let i = 0; i < buf.length; i++) c = CRC_TABLE[(c ^ buf[i]) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
};

const createZip = async (files, onProgress) => {
  const enc = new TextEncoder();
  const now = new Date();
  const dosTime = (now.getHours() << 11) | (now.getMinutes() << 5) | (now.getSeconds() >> 1);
  const dosDate = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();

  const parts = [];
  const central = [];
  let offset = 0;
  let centralSize = 0;

  for (let i = 0; i < files.length; i++) {
    const f = files[i];
    const data = new Uint8Array(await f.blob.arrayBuffer());
    const name = enc.encode(f.name);
    const crc = crc32(data);

    const lh = new DataView(new ArrayBuffer(30));
    lh.setUint32(0, 0x04034b50, true);
    lh.setUint16(4, 20, true);
    lh.setUint16(6, 0x0800, true);
    lh.setUint16(10, dosTime, true);
    lh.setUint16(12, dosDate, true);
    lh.setUint32(14, crc, true);
    lh.setUint32(18, data.length, true);
    lh.setUint32(22, data.length, true);
    lh.setUint16(26, name.length, true);
    parts.push(lh.buffer, name, data);

    const ch = new DataView(new ArrayBuffer(46));
    ch.setUint32(0, 0x02014b50, true);
    ch.setUint16(4, 20, true);
    ch.setUint16(6, 20, true);
    ch.setUint16(8, 0x0800, true);
    ch.setUint16(12, dosTime, true);
    ch.setUint16(14, dosDate, true);
    ch.setUint32(16, crc, true);
    ch.setUint32(20, data.length, true);
    ch.setUint32(24, data.length, true);
    ch.setUint16(28, name.length, true);
    ch.setUint32(42, offset, true);
    central.push(ch.buffer, name);

    offset += 30 + name.length + data.length;
    centralSize += 46 + name.length;

    if (onProgress) await onProgress(i + 1, files.length);
  }

  const end = new DataView(new ArrayBuffer(22));
  end.setUint32(0, 0x06054b50, true);
  end.setUint16(8, files.length, true);
  end.setUint16(10, files.length, true);
  end.setUint32(12, centralSize, true);
  end.setUint32(16, offset, true);

  return new Blob([...parts, ...central, end.buffer], { type: "application/zip" });
};

/* ---- Naming --------------------------------------------------------- */

/* Name rule: take the file name (without extension), split it by "-", and pick the
   part that starts with "SWPS" or "MICDA". Any "/" or "\" inside that part becomes "_".
   "abc-SWPS123-01.jpg"   ->  ["abc", "SWPS123", "01"]  ->  "SWPS123"
   "abc-MICDA45\7-01.jpg" ->  ["abc", "MICDA45\7", "01"] ->  "MICDA45_7"
   If no part starts with SWPS / MICDA, the whole file name (without extension) is used. */
const NAME_PREFIX = /^(SWPS|MICDA)/i;

const shortName = (path) => {
  const fileName = path.split("/").pop();
  const stem = fileName.replace(/\.[^./]+$/, "");
  const match = stem
    .split("-")
    .map((s) => s.trim())
    .find((s) => NAME_PREFIX.test(s));
  return (match || stem).replace(/[\\/]/g, "_");
};

// Original extension is kept (no re-encoding), so the file is never mislabelled.
const extOf = (path) => {
  const m = path.split("/").pop().match(/\.([^./]+)$/);
  return m ? m[1].toLowerCase() : "jpg";
};

const toOutPath = (path, keepFolders) => {
  const dir = keepFolders ? path.split("/").slice(0, -1).join("/") : "";
  return `${dir ? dir + "/" : ""}${shortName(path)}.${extOf(path)}`;
};

/* ---- Minimal XLSX writer (an .xlsx file is a zip of XML parts) ------ */

const xmlEsc = (v) =>
  String(v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

const createXlsx = async (sheetName, headers, rows) => {
  const all = [headers, ...rows];
  const col = (i) => String.fromCharCode(65 + i);
  const widths = headers.map((_, c) =>
    Math.min(60, Math.max(10, ...all.map((r) => String(r[c] ?? "").length + 2)))
  );

  const sheetData = all
    .map((row, r) => {
      const cells = row
        .map((v, c) => {
          const ref = `${col(c)}${r + 1}`;
          const style = r === 0 ? ' s="1"' : "";
          return typeof v === "number"
            ? `<c r="${ref}"${style}><v>${v}</v></c>`
            : `<c r="${ref}"${style} t="inlineStr"><is><t xml:space="preserve">${xmlEsc(v)}</t></is></c>`;
        })
        .join("");
      return `<row r="${r + 1}">${cells}</row>`;
    })
    .join("");

  const head = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>';
  const ns = "http://schemas.openxmlformats.org/spreadsheetml/2006/main";
  const rel = "http://schemas.openxmlformats.org/officeDocument/2006/relationships";
  const pkg = "http://schemas.openxmlformats.org/package/2006/relationships";

  const sheet = `${head}<worksheet xmlns="${ns}"><sheetViews><sheetView workbookViewId="0"><pane ySplit="1" topLeftCell="A2" activePane="bottomLeft" state="frozen"/></sheetView></sheetViews><cols>${widths
    .map((w, i) => `<col min="${i + 1}" max="${i + 1}" width="${w}" customWidth="1"/>`)
    .join("")}</cols><sheetData>${sheetData}</sheetData><autoFilter ref="A1:${col(headers.length - 1)}${all.length}"/></worksheet>`;

  const styles = `${head}<styleSheet xmlns="${ns}"><fonts count="2"><font><sz val="11"/><name val="Calibri"/></font><font><b/><sz val="11"/><name val="Calibri"/></font></fonts><fills count="3"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FFCA8A04"/><bgColor indexed="64"/></patternFill></fill></fills><borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders><cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="2"><xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/><xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/></cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles></styleSheet>`;

  const parts = [
    {
      name: "[Content_Types].xml",
      text: `${head}<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/></Types>`,
    },
    {
      name: "_rels/.rels",
      text: `${head}<Relationships xmlns="${pkg}"><Relationship Id="rId1" Type="${rel}/officeDocument" Target="xl/workbook.xml"/></Relationships>`,
    },
    {
      name: "xl/workbook.xml",
      text: `${head}<workbook xmlns="${ns}" xmlns:r="${rel}"><sheets><sheet name="${xmlEsc(sheetName)}" sheetId="1" r:id="rId1"/></sheets></workbook>`,
    },
    {
      name: "xl/_rels/workbook.xml.rels",
      text: `${head}<Relationships xmlns="${pkg}"><Relationship Id="rId1" Type="${rel}/worksheet" Target="worksheets/sheet1.xml"/><Relationship Id="rId2" Type="${rel}/styles" Target="styles.xml"/></Relationships>`,
    },
    { name: "xl/worksheets/sheet1.xml", text: sheet },
    { name: "xl/styles.xml", text: styles },
  ];

  const zip = await createZip(parts.map((p) => ({ name: p.name, blob: new Blob([p.text]) })));
  return new Blob([zip], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
};

const Icon = ({ children, className = "w-5 h-5" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

const FolderIcon = (p) => (
  <Icon {...p}>
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />
  </Icon>
);
const ImagesIcon = (p) => (
  <Icon {...p}>
    <rect x="3" y="4" width="18" height="16" rx="2" />
    <circle cx="9" cy="10" r="1.5" />
    <path d="m21 16-5-5-8 8" />
  </Icon>
);
const DownloadIcon = (p) => (
  <Icon {...p}>
    <path d="M12 4v12M7 11l5 5 5-5M4 20h16" />
  </Icon>
);
const CloseIcon = (p) => (
  <Icon {...p}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Icon>
);
const TrashIcon = (p) => (
  <Icon {...p}>
    <path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12M9 7V4h6v3" />
  </Icon>
);
const CheckIcon = (p) => (
  <Icon {...p}>
    <path d="m5 12 5 5 9-10" />
  </Icon>
);
const CopyIcon = (p) => (
  <Icon {...p}>
    <rect x="8" y="8" width="12" height="12" rx="2" />
    <path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" />
  </Icon>
);
const SparkIcon = (p) => (
  <Icon {...p}>
    <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M18 6l-2.5 2.5M8.5 15.5 6 18" />
  </Icon>
);
const BoltIcon = (p) => (
  <Icon {...p}>
    <path d="M13 3 5 14h6l-1 7 8-11h-6l1-7Z" />
  </Icon>
);
const ArrowUpIcon = (p) => (
  <Icon {...p}>
    <path d="M12 19V5M6 11l6-6 6 6" />
  </Icon>
);
const ArrowDownIcon = (p) => (
  <Icon {...p}>
    <path d="M12 5v14M6 13l6 6 6-6" />
  </Icon>
);

/* ------------------------------------------------------------------ */
/* Small UI pieces (light theme)                                       */
/* ------------------------------------------------------------------ */

const Segmented = ({ options, value, onChange }) => (
  <div className="flex rounded-xl bg-black/5 p-1">
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        onClick={() => onChange(o.value)}
        aria-pressed={value === o.value}
        className={`flex-1 rounded-lg px-3 py-2 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 ${value === o.value
            ? "bg-white text-black shadow-sm ring-1 ring-black/10"
            : "text-black/60 hover:text-black"
          }`}
      >
        {o.label}
      </button>
    ))}
  </div>
);

const Control = ({ label, hint, children }) => (
  <div className="flex flex-col gap-2.5">
    <div className="flex items-center justify-between gap-3">
      <span className="text-black">{label}</span>
      {hint && (
        <span className="rounded-md bg-yellow-600/15 px-2 py-0.5 text-black ring-1 ring-yellow-600/40">
          {hint}
        </span>
      )}
    </div>
    {children}
  </div>
);

const stripes = {
  backgroundImage:
    "repeating-linear-gradient(135deg, rgba(255,255,255,0.8) 0 12px, rgba(202,138,4,0.3) 12px 14px)",
};

const dots = {
  backgroundImage: "radial-gradient(rgba(0,0,0,0.09) 1px, transparent 1px)",
  backgroundSize: "22px 22px",
};

const primaryBtn =
  "flex items-center justify-center gap-2 rounded-xl bg-yellow-600 px-6 py-3.5 text-black shadow-sm transition hover:bg-black hover:text-white disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2";
const secondaryBtn =
  "flex items-center justify-center gap-2 rounded-xl border border-black/15 bg-white px-6 py-3.5 text-black transition hover:border-black disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 focus-visible:ring-offset-2";

const DropZone = ({ dragging, busy, onPickFolder, onPickFiles, compact }) =>
  compact ? (
    <div
      className={`flex flex-col gap-4 rounded-2xl border-2 border-dashed p-4 transition sm:flex-row sm:items-center sm:justify-between ${dragging ? "border-yellow-600 bg-yellow-600/15" : "border-yellow-600/50 bg-yellow-600/5"
        }`}
    >
      <div className="flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-yellow-600 shadow-sm ring-1 ring-yellow-600/30">
          <FolderIcon className="h-5 w-5" />
        </span>
        <div>
          <div className="text-black">{dragging ? "Release to add" : "Add more images"}</div>
          <div className="text-black/55">Or drop another folder anywhere on this page.</div>
        </div>
      </div>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={onPickFolder}
          disabled={busy}
          className="flex-1 rounded-xl bg-yellow-600 px-4 py-2.5 text-black transition hover:bg-black hover:text-white disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 sm:flex-none"
        >
          Folder
        </button>
        <button
          type="button"
          onClick={onPickFiles}
          disabled={busy}
          className="flex-1 rounded-xl border border-black/15 bg-white px-4 py-2.5 text-black transition hover:border-black disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 focus-visible:ring-offset-2 sm:flex-none"
        >
          Files
        </button>
      </div>
    </div>
  ) : (
    <div
      className={`rounded-3xl border-2 border-dashed p-8 text-center shadow-xl shadow-black/5 transition sm:p-12 ${dragging ? "border-yellow-600 bg-yellow-600/15" : "border-yellow-600/60 bg-white"
        }`}
    >
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-yellow-600/10 text-yellow-600 ring-1 ring-yellow-600/30">
        <FolderIcon className="h-10 w-10" />
      </div>
      <h2 className="mt-6 text-black">{dragging ? "Release to add this folder" : "Drop your folder here"}</h2>
      <p className="mx-auto mt-2 max-w-xs text-black/55">
        Subfolders are included. Anything that isn't an image is skipped.
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:justify-center">
        <button type="button" onClick={onPickFolder} disabled={busy} className={primaryBtn}>
          <FolderIcon className="h-5 w-5" />
          Choose folder
        </button>
        <button type="button" onClick={onPickFiles} disabled={busy} className={secondaryBtn}>
          <ImagesIcon className="h-5 w-5" />
          Choose files
        </button>
      </div>
    </div>
  );

const StatCard = ({ icon, label, value, sub, accent }) => (
  <div
    className={`rounded-2xl border p-4 shadow-sm ${accent ? "border-yellow-600/40 bg-yellow-600/10" : "border-black/10 bg-white"
      }`}
  >
    <div className="flex items-center gap-2 text-black/60">
      <span
        className={`flex h-7 w-7 items-center justify-center rounded-lg ${accent ? "bg-yellow-600 text-black" : "bg-black/5 text-black"
          }`}
      >
        {icon}
      </span>
      {label}
    </div>
    <div className="mt-3 text-black">{value}</div>
    <div className="text-black/50">{sub}</div>
  </div>
);

/* One image card, used in every gallery view */
const ImageCard = ({ it, dup, onRemove, onKeep, note }) => {
  const dir = it.path.split("/").slice(0, -1).join("/");
  return (
    <li
      className={`flex flex-col overflow-hidden rounded-2xl border bg-white shadow-sm transition hover:shadow-lg hover:shadow-black/10 ${dup ? "border-yellow-600" : "border-black/10"
        }`}
    >
      <div className="relative aspect-square bg-black/5">
        <img
          src={it.url}
          alt={it.file.name}
          loading="lazy"
          className="h-full w-full object-cover"
        />
        {dup && <div className="absolute inset-0" style={stripes} />}
        <span
          className={`absolute left-2 top-2 flex items-center gap-1.5 rounded-full px-2.5 py-1 shadow-sm ${dup ? "bg-black text-white" : "bg-white text-black ring-1 ring-black/10"
            }`}
        >
          {!dup && <span className="h-2 w-2 rounded-full bg-yellow-600" />}
          {dup ? "Duplicate" : "Keeping"}
        </span>
        <button
          type="button"
          onClick={() => onRemove(it.id)}
          aria-label={`Remove ${it.file.name}`}
          className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-white text-black shadow transition hover:bg-black hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
        >
          <CloseIcon className="h-4 w-4" />
        </button>
        <span className="absolute bottom-2 right-2 rounded-md bg-black/70 px-1.5 py-0.5 uppercase text-white">
          {extOf(it.path)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <div className="truncate text-black" title={it.file.name}>
          {it.file.name}
        </div>
        {dir && (
          <div className="truncate text-black/45" title={dir}>
            {dir}
          </div>
        )}
        <div className="text-black/60">
          {formatBytes(it.file.size)} · {it.w}×{it.h}
        </div>
        {!dup && (
          <div className="mt-1 truncate text-black/45">
            Saved as {shortName(it.path)}.{extOf(it.path)}
          </div>
        )}
        {dup && (
          <div className="mt-auto border-t border-black/10 pt-2">
            {note && (
              <div className="truncate text-black/70" title={note}>
                {note}
              </div>
            )}
            <button
              type="button"
              onClick={() => onKeep(it.id)}
              className="mt-1 rounded text-black underline decoration-yellow-600 decoration-2 underline-offset-4 hover:bg-yellow-600/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
            >
              Keep anyway
            </button>
          </div>
        )}
      </div>
    </li>
  );
};

/* ------------------------------------------------------------------ */
/* Page                                                                */
/* ------------------------------------------------------------------ */

export default function DuplicateImageCleaner() {
  const [items, setItems] = useState([]);
  const [mode, setMode] = useState("exact");
  const [keepFolders, setKeepFolders] = useState(true);
  const [filter, setFilter] = useState("groups");
  const [keepIds, setKeepIds] = useState(() => new Set());
  const [dragging, setDragging] = useState(false);
  const [status, setStatus] = useState(null); // { label, done, total }
  const [result, setResult] = useState(null);
  const [scrollInfo, setScrollInfo] = useState({ atTop: true, atBottom: false, scrollable: false });
  const folderRef = useRef(null);
  const filesRef = useRef(null);
  const urlsRef = useRef([]);
  const busy = status !== null;

  useEffect(
    () => () => {
      urlsRef.current.forEach((u) => URL.revokeObjectURL(u));
    },
    []
  );

  const clearResult = useCallback(() => {
    setResult((prev) => {
      if (prev) URL.revokeObjectURL(prev.url);
      return null;
    });
  }, []);

  /* ---- Scroll tracking for the jump buttons ---- */
  useEffect(() => {
    const update = () => {
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setScrollInfo({ atTop: y < 80, atBottom: y > max - 80, scrollable: max > 300 });
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    const t = setTimeout(update, 300); // after images lay out
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
      clearTimeout(t);
    };
  }, [items.length, filter]);

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const goBottom = () =>
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });

  /* ---- Add files (folder picker, file picker or drop) ---- */
  const addEntries = useCallback(
    async (entries) => {
      const images = entries.filter((e) => e.file.type.startsWith("image/"));
      if (!images.length) {
        setStatus(null);
        return;
      }
      clearResult();
      const added = [];
      const BATCH = 4;
      for (let i = 0; i < images.length; i += BATCH) {
        setStatus({ label: "Scanning images", done: i, total: images.length });
        const done = await Promise.all(
          images.slice(i, i + BATCH).map(async ({ file, path }, k) => {
            try {
              const [hash, bmp] = await Promise.all([sha256(file), loadBitmap(file)]);
              const { w, h } = sizeOf(bmp);
              const bits = dHash(bmp);
              if (bmp.close) bmp.close();
              const url = URL.createObjectURL(file);
              urlsRef.current.push(url);
              return {
                id: `${Date.now()}-${i + k}-${Math.random().toString(36).slice(2, 7)}`,
                file,
                path,
                url,
                hash,
                dhash: bits,
                w,
                h,
              };
            } catch {
              return null; // unreadable file
            }
          })
        );
        added.push(...done.filter(Boolean));
      }
      setItems((prev) => [...prev, ...added]);
      setStatus(null);
    },
    [clearResult]
  );

  const fromInput = (e) => {
    const entries = Array.from(e.target.files || []).map((file) => ({
      file,
      path: file.webkitRelativePath || file.name,
    }));
    e.target.value = "";
    addEntries(entries);
  };

  const onDrop = async (e) => {
    e.preventDefault();
    setDragging(false);
    setStatus({ label: "Reading folder", done: 0, total: 1 });
    // Entries must be grabbed synchronously, before any await.
    const roots = Array.from(e.dataTransfer.items || [])
      .map((i) => (i.webkitGetAsEntry ? i.webkitGetAsEntry() : null))
      .filter(Boolean);
    const plain = Array.from(e.dataTransfer.files || []);
    const out = [];
    try {
      if (roots.length) for (const r of roots) await walkEntry(r, "", out);
      else plain.forEach((file) => out.push({ file, path: file.name }));
    } catch {
      plain.forEach((file) => out.push({ file, path: file.name }));
    }
    addEntries(out);
  };

  /* ---- Duplicate analysis ---- */
  const { dupMap, keptItems } = useMemo(() => {
    const kept = [];
    const map = {};
    for (const it of items) {
      let match = null;
      let reason = "";
      for (const k of kept) {
        if (k.hash === it.hash) {
          match = k;
          reason = "Identical to";
          break;
        }
        if (mode === "similar") {
          const sameShape = Math.abs(k.w / k.h - it.w / it.h) < 0.03;
          if (sameShape && hamming(k.dhash, it.dhash) <= 4) {
            match = k;
            reason = "Looks like";
            break;
          }
        }
      }
      if (match && !keepIds.has(it.id)) map[it.id] = { of: match, reason };
      else kept.push(it);
    }
    return { dupMap: map, keptItems: kept };
  }, [items, mode, keepIds]);

  const dupCount = items.length - keptItems.length;

  // Groups: each kept image followed by the images identical to it, in upload order.
  const groups = useMemo(() => {
    const m = new Map();
    items.forEach((it) => {
      const d = dupMap[it.id];
      if (!d) return;
      if (!m.has(d.of.id)) m.set(d.of.id, { original: d.of, dups: [] });
      m.get(d.of.id).dups.push(it);
    });
    return keptItems
      .filter((k) => m.has(k.id))
      .map((k, i) => ({ no: i + 1, ...m.get(k.id) }));
  }, [items, dupMap, keptItems]);

  const totalBytes = items.reduce((s, i) => s + i.file.size, 0);
  const keptBytes = keptItems.reduce((s, i) => s + i.file.size, 0);
  const dupBytes = totalBytes - keptBytes;
  const folderCount = new Set(
    items.map((i) => i.path.split("/").slice(0, -1).join("/")).filter(Boolean)
  ).size;

  const visible = items.filter((i) =>
    filter === "all" ? true : filter === "duplicates" ? !!dupMap[i.id] : !dupMap[i.id]
  );

  /* ---- Item actions ---- */
  const removeItem = (id) => {
    clearResult();
    setItems((prev) => prev.filter((i) => i.id !== id));
  };
  const keepAnyway = (id) => {
    clearResult();
    setKeepIds((prev) => new Set(prev).add(id));
  };
  const clearAll = () => {
    clearResult();
    urlsRef.current.forEach((u) => URL.revokeObjectURL(u));
    urlsRef.current = [];
    setItems([]);
    setKeepIds(new Set());
    setFilter("groups");
  };
  const change = (setter) => (value) => {
    clearResult();
    setter(value);
  };

  /* ---- Downloads ---- */
  const download = (url, filename = "unique-images.zip") => {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  const downloadExcel = async () => {
    if (!groups.length || busy) return;
    const headers = [
      "S.No",
      "Group",
      "Name",
      "File Name",
      "File Path",
      "Identical To (Name)",
      "Identical To (File)",
      "Match",
      "Size (KB)",
    ];
    const rows = [];
    groups.forEach((g) =>
      g.dups.forEach((d) =>
        rows.push([
          rows.length + 1,
          g.no,
          shortName(d.path), // SWPS / MICDA part of the file name
          d.file.name,
          d.path,
          shortName(g.original.path),
          g.original.file.name,
          dupMap[d.id].reason === "Identical to" ? "Identical" : "Similar",
          Math.round(d.file.size / 102.4) / 10,
        ])
      )
    );
    const blob = await createXlsx("Duplicate images", headers, rows);
    const url = URL.createObjectURL(blob);
    download(url, "duplicate-images.xlsx");
    setTimeout(() => URL.revokeObjectURL(url), 10000);
  };

  // Fast path: original files are copied into the zip as they are (no re-encoding).
  const buildZip = async () => {
    if (!keptItems.length || busy) return;
    clearResult();
    const used = new Set();
    const out = keptItems.map((it) => {
      const base = toOutPath(it.path, keepFolders);
      let name = base;
      let n = 1;
      while (used.has(name.toLowerCase())) {
        name = base.replace(/(\.[^./]+)$/, `_${n}$1`);
        n++;
      }
      used.add(name.toLowerCase());
      return { name, blob: it.file };
    });

    setStatus({ label: "Creating zip", done: 0, total: out.length });
    let lastPaint = 0;
    const zip = await createZip(out, async (done, total) => {
      const now = performance.now();
      if (done === total || now - lastPaint > 120) {
        lastPaint = now;
        setStatus({ label: "Creating zip", done, total });
        await new Promise((res) => setTimeout(res, 0)); // let the UI repaint
      }
    });
    const url = URL.createObjectURL(zip);
    setResult({ url, count: out.length, size: zip.size });
    setStatus(null);
    download(url);
  };

  const hasItems = items.length > 0;

  const openFolder = () => folderRef.current?.click();
  const openFiles = () => filesRef.current?.click();

  const dropProps = {
    onDragOver: (e) => {
      e.preventDefault();
      setDragging(true);
    },
    onDragLeave: (e) => {
      if (e.currentTarget === e.target) setDragging(false);
    },
    onDrop,
  };

  const progress = status && (
    <div role="status">
      <div className="flex justify-between text-black/70">
        <span>{status.label}</span>
        <span>
          {status.done} / {status.total}
        </span>
      </div>
      <div className="mt-2 h-2 overflow-hidden rounded-full bg-black/10">
        <div
          className="h-full rounded-full bg-yellow-600 transition-all"
          style={{ width: `${Math.max(5, (status.done / status.total) * 100)}%` }}
        />
      </div>
    </div>
  );

  const mainAction = result ? () => download(result.url) : buildZip;
  const mainLabel = busy ? "Working…" : result ? "Download zip again" : "Remove duplicates & download";

  /* ------------------------------------------------------------------ */

  return (
    <div className="min-h-screen bg-white text-black" {...dropProps}>
      <input
        ref={folderRef}
        type="file"
        multiple
        webkitdirectory=""
        directory=""
        className="hidden"
        onChange={fromInput}
      />
      <input ref={filesRef} type="file" accept="image/*" multiple className="hidden" onChange={fromInput} />

      {/* ---------------- Empty state ---------------- */}
      {!hasItems && (
        <>
          <section className="relative overflow-hidden" style={dots}>
            <div className="pointer-events-none absolute -left-32 -top-32 h-96 w-96 rounded-full bg-yellow-600/15 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-40 right-0 h-96 w-96 rounded-full bg-yellow-600/10 blur-3xl" />
            <div className="relative mx-auto grid max-w-7xl items-center gap-12 px-4 py-14 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24">
              <div>
                <span className="inline-flex items-center gap-2 rounded-full bg-yellow-600/15 px-3 py-1.5 text-black ring-1 ring-yellow-600/40">
                  <SparkIcon className="h-4 w-4 text-yellow-600" />
                  Fast duplicate image remover
                </span>
                <h1 className="mt-5 max-w-xl text-black">
                  Turn a messy folder of images into one clean zip, instantly.
                </h1>
                <p className="mt-4 max-w-lg text-black/60">
                  Upload a folder, we remove the duplicates and zip the rest. Images are copied as
                  they are, with no re-compression, so the download is quick and quality is untouched.
                </p>

                <dl className="mt-10 grid max-w-lg grid-cols-3 gap-4">
                  {[
                    ["Folders", "with subfolders"],
                    ["Original", "quality kept"],
                    ["0 uploads", "all in-browser"],
                  ].map(([a, b]) => (
                    <div key={a} className="border-l-2 border-yellow-600 pl-3">
                      <dt className="text-black">{a}</dt>
                      <dd className="text-black/55">{b}</dd>
                    </div>
                  ))}
                </dl>
              </div>

              <div>
                <DropZone
                  dragging={dragging}
                  busy={busy}
                  onPickFolder={openFolder}
                  onPickFiles={openFiles}
                />
                {status && (
                  <div className="mt-5 rounded-2xl border border-black/10 bg-white p-4 shadow-sm">
                    {progress}
                  </div>
                )}
              </div>
            </div>
          </section>

          <section className="border-t border-black/10 bg-black/[0.03]">
            <div className="mx-auto grid max-w-7xl gap-4 px-4 py-14 sm:px-6 md:grid-cols-3 lg:px-8">
              {[
                [<CopyIcon key="i" className="h-5 w-5" />, "Finds duplicates", "Exact copies are caught every time. Turn on Similar to also catch re-saved or resized copies."],
                [<BoltIcon key="i" className="h-5 w-5" />, "Quick download", "No resizing or re-encoding. Original files go straight into the zip."],
                [<DownloadIcon key="i" className="h-5 w-5" />, "Zips it for you", "Folder structure is kept, and each file is renamed to its SWPS or MICDA code taken from the file name."],
              ].map(([icon, t, d]) => (
                <div key={t} className="rounded-2xl border border-black/10 bg-white p-6 shadow-sm">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-yellow-600/15 text-yellow-600 ring-1 ring-yellow-600/30">
                    {icon}
                  </span>
                  <div className="mt-4 text-black">{t}</div>
                  <p className="mt-2 text-black/60">{d}</p>
                </div>
              ))}
            </div>
          </section>
        </>
      )}

      {/* ---------------- Workbench ---------------- */}
      {hasItems && (
        <main className="mx-auto grid max-w-7xl gap-8 bg-white px-4 py-8 pb-32 sm:px-6 lg:grid-cols-[22rem_minmax(0,1fr)] lg:px-8 lg:pb-12">
          {/* Settings panel */}
          <aside className="self-start lg:sticky lg:top-6">
            <div className="rounded-3xl border border-black/10 bg-white p-5 shadow-xl shadow-black/5 sm:p-6">
              <div className="flex items-center justify-between">
                <h2 className="flex items-center gap-2 text-black">
                  <span className="h-2.5 w-2.5 rounded-full bg-yellow-600" />
                  Output settings
                </h2>
                <span className="rounded-md bg-black px-2.5 py-1 text-white">original format</span>
              </div>

              <div className="mt-6 grid gap-6">
                <Control label="Duplicate detection" hint={mode === "exact" ? "Strict" : "Flexible"}>
                  <Segmented
                    value={mode}
                    onChange={change(setMode)}
                    options={[
                      { value: "exact", label: "Exact" },
                      { value: "similar", label: "Similar" },
                    ]}
                  />
                </Control>

                <Control label="Zip layout">
                  <Segmented
                    value={keepFolders ? "keep" : "flat"}
                    onChange={(v) => change(setKeepFolders)(v === "keep")}
                    options={[
                      { value: "keep", label: "Keep folders" },
                      { value: "flat", label: "Flat" },
                    ]}
                  />
                </Control>

                <p className="rounded-xl bg-yellow-600/10 p-3 text-black/70 ring-1 ring-yellow-600/30">
                  The file name is split by “-” and the part starting with{" "}
                  <span className="text-black">SWPS</span> or <span className="text-black">MICDA</span>{" "}
                  is used as the new name (any “/” or “\” in it becomes “_”). For example,{" "}
                  <span className="text-black">abc-SWPS123-01.png</span> is saved as{" "}
                  <span className="text-black">SWPS123.png</span>. Images are not re-compressed.
                </p>
              </div>

              <div className="mt-6 rounded-2xl bg-black/[0.04] p-4">
                {result ? (
                  <div>
                    <div className="flex items-center justify-between gap-3">
                      <span className="text-black/60">Zip ready</span>
                      <span className="rounded-md bg-yellow-600 px-2 py-0.5 text-black">
                        {result.count} images
                      </span>
                    </div>
                    <div className="mt-2 text-black">{formatBytes(result.size)}</div>
                  </div>
                ) : (
                  <div className="flex items-end justify-between gap-3">
                    <div>
                      <div className="text-black/60">Ready to process</div>
                      <div className="mt-1 text-black">{keptItems.length} images</div>
                    </div>
                    <div className="text-black/60">{formatBytes(keptBytes)}</div>
                  </div>
                )}
                {busy && <div className="mt-4">{progress}</div>}
              </div>

              <button
                type="button"
                onClick={mainAction}
                disabled={busy || !keptItems.length}
                className={`${primaryBtn} mt-5 hidden w-full lg:flex`}
              >
                <DownloadIcon className="h-5 w-5" />
                {mainLabel}
              </button>
            </div>
          </aside>

          {/* Gallery */}
          <section className="min-w-0">
            <DropZone
              compact
              dragging={dragging}
              busy={busy}
              onPickFolder={openFolder}
              onPickFiles={openFiles}
            />

            <div className="mt-6 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
              <StatCard
                icon={<ImagesIcon className="h-4 w-4" />}
                label="Found"
                value={items.length}
                sub={`${folderCount ? folderCount + " folders · " : ""}${formatBytes(totalBytes)}`}
              />
              <StatCard
                accent
                icon={<CopyIcon className="h-4 w-4" />}
                label="Duplicates"
                value={dupCount}
                sub={`${formatBytes(dupBytes)} freed`}
              />
              <StatCard
                icon={<CheckIcon className="h-4 w-4" />}
                label="Unique"
                value={keptItems.length}
                sub={formatBytes(keptBytes)}
              />
              <StatCard
                icon={<DownloadIcon className="h-4 w-4" />}
                label="Zip size"
                value={result ? formatBytes(result.size) : "—"}
                sub={result ? `${result.count} images` : "after download"}
              />
            </div>

            {/* Sticky toolbar: tabs + actions stay visible while scrolling */}
            <div className="sticky top-0 z-10 -mx-4 mt-6 border-b border-black/10 bg-white/95 px-4 py-3 backdrop-blur sm:-mx-6 sm:px-6 lg:mx-0 lg:rounded-2xl lg:border lg:px-3">
              <div className="flex flex-wrap items-center justify-between gap-3">
                <div className="flex max-w-full overflow-x-auto rounded-xl bg-black/5 p-1">
                  {[
                    { v: "groups", l: "By image", n: groups.length },
                    { v: "all", l: "All", n: items.length },
                    { v: "unique", l: "Unique", n: keptItems.length },
                    { v: "duplicates", l: "Duplicates", n: dupCount },
                  ].map((t) => (
                    <button
                      key={t.v}
                      type="button"
                      onClick={() => setFilter(t.v)}
                      aria-pressed={filter === t.v}
                      className={`flex items-center gap-2 whitespace-nowrap rounded-lg px-4 py-2 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600 ${filter === t.v
                          ? "bg-white text-black shadow-sm ring-1 ring-black/10"
                          : "text-black/60 hover:text-black"
                        }`}
                    >
                      {t.l}
                      <span
                        className={`rounded-md px-1.5 ${filter === t.v ? "bg-yellow-600 text-black" : "bg-black/10 text-black"
                          }`}
                      >
                        {t.n}
                      </span>
                    </button>
                  ))}
                </div>
                <div className="flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={downloadExcel}
                    disabled={busy || !groups.length}
                    className="flex items-center gap-2 rounded-xl bg-yellow-600 px-4 py-2.5 text-black shadow-sm transition hover:bg-black hover:text-white disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
                  >
                    <DownloadIcon className="h-4 w-4" />
                    Duplicates Excel
                  </button>
                  <button
                    type="button"
                    onClick={clearAll}
                    disabled={busy}
                    className="flex items-center gap-2 rounded-xl border border-black/15 bg-white px-4 py-2.5 text-black transition hover:border-black disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-yellow-600"
                  >
                    <TrashIcon className="h-4 w-4" />
                    Start over
                  </button>
                </div>
              </div>
            </div>

            {filter === "groups" ? (
              groups.length === 0 ? (
                <div className="mt-6 rounded-2xl border border-dashed border-black/20 p-12 text-center text-black/55">
                  No duplicates found. Open the All tab to see every image.
                </div>
              ) : (
                <ol className="mt-6 grid gap-6">
                  {groups.map((g) => (
                    <li
                      key={g.original.id}
                      className="overflow-hidden rounded-3xl border border-black/10 bg-white shadow-sm"
                    >
                      {/* Group header: the image being kept */}
                      <div className="flex flex-wrap items-center gap-4 border-b border-black/10 bg-yellow-600/10 p-4">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-yellow-600 text-black">
                          {g.no}
                        </span>
                        <img
                          src={g.original.url}
                          alt={g.original.file.name}
                          className="h-24 w-24 shrink-0 rounded-2xl object-cover ring-1 ring-black/10"
                        />
                        <div className="min-w-0 flex-1">
                          <div className="text-black/55">Original (kept)</div>
                          <div className="truncate text-black" title={g.original.path}>
                            {g.original.file.name}
                          </div>
                          <div className="truncate text-black/55">
                            {formatBytes(g.original.file.size)} · {g.original.w}×{g.original.h}
                          </div>
                          <div className="mt-1 text-black/55">
                            Saved as{" "}
                            <span className="rounded bg-white px-1.5 text-black ring-1 ring-yellow-600/40">
                              {shortName(g.original.path)}.{extOf(g.original.path)}
                            </span>
                          </div>
                        </div>
                        <span className="rounded-full bg-black px-3 py-1 text-white">
                          {g.dups.length} {g.dups.length === 1 ? "duplicate" : "duplicates"}
                        </span>
                      </div>

                      {/* Duplicates as a clean grid of cards */}
                      <ul className="grid grid-cols-2 gap-3 p-4 sm:grid-cols-3 sm:gap-4 xl:grid-cols-4">
                        {g.dups.map((d, i) => (
                          <ImageCard
                            key={d.id}
                            it={d}
                            dup
                            onRemove={removeItem}
                            onKeep={keepAnyway}
                            note={`${g.no}.${i + 1} · ${dupMap[d.id].reason === "Identical to" ? "Identical" : "Similar"
                              } to original`}
                          />
                        ))}
                      </ul>
                    </li>
                  ))}
                </ol>
              )
            ) : visible.length === 0 ? (
              <div className="mt-6 rounded-2xl border border-dashed border-black/20 p-12 text-center text-black/55">
                No images in this view.
              </div>
            ) : (
              <ul className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 xl:grid-cols-4">
                {visible.map((it) => {
                  const dup = dupMap[it.id];
                  return (
                    <ImageCard
                      key={it.id}
                      it={it}
                      dup={!!dup}
                      onRemove={removeItem}
                      onKeep={keepAnyway}
                      note={dup ? `${dup.reason} ${dup.of.file.name}` : ""}
                    />
                  );
                })}
              </ul>
            )}
          </section>
        </main>
      )}

      {/* Jump to top / bottom */}
      {hasItems && scrollInfo.scrollable && (
        <div className="fixed bottom-24 right-4 z-30 flex flex-col gap-2 lg:bottom-6 lg:right-6">
          <button
            type="button"
            onClick={goTop}
            disabled={scrollInfo.atTop}
            aria-label="Go to top"
            title="Go to top"
            className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-black shadow-lg ring-1 ring-black/10 transition hover:bg-black hover:text-white disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
          >
            <ArrowUpIcon className="h-6 w-6" />
          </button>
          <button
            type="button"
            onClick={goBottom}
            disabled={scrollInfo.atBottom}
            aria-label="Go to bottom"
            title="Go to bottom"
            className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-600 text-black shadow-lg ring-1 ring-black/10 transition hover:bg-black hover:text-white disabled:opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
          >
            <ArrowDownIcon className="h-6 w-6" />
          </button>
        </div>
      )}

      {/* Mobile action bar */}
      {hasItems && (
        <div className="fixed inset-x-0 bottom-0 z-20 border-t border-black/10 bg-white/95 p-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)] backdrop-blur lg:hidden">
          <div className="mx-auto flex max-w-xl items-center gap-3">
            <div className="min-w-0 flex-1 text-black/70">
              {result ? (
                <span className="text-black">
                  {result.count} images · {formatBytes(result.size)}
                </span>
              ) : (
                <span>
                  {keptItems.length} images · {formatBytes(keptBytes)}
                </span>
              )}
            </div>
            <button
              type="button"
              onClick={mainAction}
              disabled={busy || !keptItems.length}
              className="flex shrink-0 items-center gap-2 rounded-xl bg-yellow-600 px-4 py-3 text-black shadow-sm disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-black"
            >
              <DownloadIcon className="h-5 w-5" />
              {busy ? "Working…" : result ? "Download again" : "Download zip"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}